'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getWordAt = require('./getWordAt');

var _getWordAt2 = _interopRequireDefault(_getWordAt);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getSearchText = function getSearchText(editorState, selection, mentionTrigger) {
  var anchorKey = selection.getAnchorKey();
  var anchorOffset = selection.getAnchorOffset() - mentionTrigger.length;
  var currentContent = editorState.getCurrentContent();
  var currentBlock = currentContent.getBlockForKey(anchorKey);
  var blockText = currentBlock.getText();
  return (0, _getWordAt2.default)(blockText, anchorOffset);
};

exports.default = getSearchText;


//////////////////
// WEBPACK FOOTER
// ./~/draft-js-mention-plugin/lib/utils/getSearchText.js
// module id = 722
// module chunks = 0